<template>
  <div>
    <my-dialog
      :title="'修改密码'"
      data-warden-title="修改密码"
      :confirmButtonText="'保存'"
      ref="changePassword"
      class="changePassword"
    >
      <change-password-with-username
        ref="passForm"
      ></change-password-with-username>
    </my-dialog>
  </div>
</template>

<script>
import MyDialog from "@/components/MyDialog.vue";
import CryptoJS from "crypto-js";
import { Message } from "element-ui";
import ChangePasswordWithUsername from "@/components/ChangePasswordWithUsername.vue";
export default {
  name: "ChangePasswordPage",
  components: {
    MyDialog,
    ChangePasswordWithUsername
  },
  data() {
    return {
      username: null
    };
  },
  mounted() {
    this.changePassword();
  },
  methods: {
    changePassword() {
      //   this.username = this.$route.query.username;
      //   alert(this.userId);
      this.$refs.changePassword.open(
        () => {
          if (
            this.$refs.passForm.flag
          ) {
            let url = "retrieve/user/login";
            let username = this.$refs.passForm.form.username.text;
            let password = this.$refs.passForm.form.oldPassword.text;
            let passwordmd5 = CryptoJS.MD5(password).toString();
            let params = new URLSearchParams();
            params.append("username", username);
            params.append("password", passwordmd5);
            this.$http
              .post(url, params)
              .then(res => {
                return res.data.data.user.id;
              })
              .then(userId => {
                url = "retrieve/user/changePasswordByUserId";
                let oldPassword = this.$refs.passForm.form.oldPassword.text;
                let newPassword = this.$refs.passForm.form.newPassword.text;
                oldPassword = CryptoJS.MD5(oldPassword).toString();
                newPassword = CryptoJS.MD5(newPassword).toString();
                let params = new URLSearchParams();
                params.append("userId", userId);
                params.append("oldPassword", oldPassword);
                params.append("newPassword", newPassword);
                this.$http
                  .post(url, params)
                  .then(res => {
                    Message({
                      type: "success",
                      message: "密码修改成功!"
                    });
                    this.$router.replace("/home");
                  })
                  .catch(err => {
                    this.changePassword();
                  });
              })
              .catch(err => {
                this.changePassword();
              });
          } else {
            Message({
              type: "error",
              message: "请检查输入!"
            });
            setTimeout(() => {
                this.changePassword();
            }, 500);
            // this.changePassword();
          }
        },
        () => {
          this.$router.replace("/home");
        }
      );
    }
  }
};
</script>

<style scoped>
.changePassword >>> .el-dialog {
  width: 350px;
  margin-top: 30vh !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ChangePasswordWithUsernamePage.vue